import React from 'react'
import { withRouter } from 'react-router-dom'
import { AppContext } from '../../Data/ContextProvider'

class Footnote extends React.Component {
  render() {
    return (
      <div className={'footnote text'}>
        <div className={'footnote__row'}>
          {this.props.footnote.map((item, index) => {
            return (
              <div key={index} className={'footnote__row text'}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: item.footnote__number
                  }}
                  className={'footnote__number'}
                />
                <div className={'footnote__text'}>{item.footnote__text}</div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

Footnote.contextType = AppContext
export default withRouter(Footnote)
